import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const whatsappAPI = axios.create({
  baseURL: `${API_BASE}/api/whatsapp-accounts`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Accept token as 1st arg to set Auth header dynamically
export const getUserWhatsappPhoneNumbers = async (authToken, params = {}) => {
  return whatsappAPI.get("/phone-numbers", {
    params,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

// 🔹 Request verification code (SMS or Voice)
export const requestWhatsappVerificationCode = async (
  authToken,
  phoneId,
  method = "SMS"
) => {
  return whatsappAPI.post(
    `/request-code/${phoneId}`,
    { method },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
};

// 🔹 Verify WhatsApp code
export const verifyWhatsappCode = async (authToken, phoneId, code) => {
  return whatsappAPI.post(
    `/verify-code/${phoneId}`,
    { code },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
};

export const registerPhoneWebhook = async (authToken, phoneId) => {
  return whatsappAPI.post(
    `/register/${phoneId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
};
